// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__zOeXU","colMin":"styles_colMin__10h0P","colCheckbox":"styles_colCheckbox__2JvCz"};